
<template>
  <v-container fluid>      
    <v-breadcrumbs class="textoAjustado" :items="breadcrumbs">
      <v-icon slot="divider">chevron_right</v-icon>
    </v-breadcrumbs>
    <v-row v-if="title !== null" class="mb-3">
      <v-col cols="12">
        <h1 class="titleColor--text display-1 text-center text-uppercase textoAjustado">{{title}}</h1>
      </v-col>
    </v-row>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: null
    }
  }
}
</script>
